(function () {
  var ORDER_VERIFICATION_PAGE = '/pages/order-verification';

  function showNativeToast(message, duration) {
    if (typeof document === 'undefined' || !document.body) return;
    duration = duration || 2000;
    var el = document.createElement('div');
    el.textContent = message;
    el.style.cssText = [
      'position:fixed',
      'top:50%',
      'left:50%',
      'transform:translate(-50%, -50%)',
      'max-width:80%',
      'padding:10px 16px',
      'background:rgba(0,0,0,0.75)',
      'color:#fff',
      'font-size:14px',
      'line-height:1.4',
      'border-radius:6px',
      'text-align:center',
      'z-index:99999',
      'pointer-events:none',
      'opacity:0',
      'transition:opacity 0.2s ease'
    ].join(';');
    document.body.appendChild(el);
    requestAnimationFrame(function () { el.style.opacity = '1'; });
    setTimeout(function () {
      el.style.opacity = '0';
      setTimeout(function () {
        if (el.parentNode) el.parentNode.removeChild(el);
      }, 250);
    }, duration);
  }

  function getToken() {
    try {
      var raw = localStorage.getItem('tor_auth');
      if (!raw) return '';
      return JSON.parse(raw).token || '';
    } catch (e) { return ''; }
  }

  function appRequest(url, opts) {
    opts = opts || {};
    opts.headers = Object.assign(
      { 'Content-Type': 'application/json', 'Authorization': getToken() },
      opts.headers || {}
    );
    return fetch(url, opts)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data && data.code === 401) {
          localStorage.removeItem('tor_auth');
          localStorage.removeItem('logined_email');
          showNativeToast('Your session has expired. Please log in again to continue.');
          if (!window.Shopify || !window.Shopify.designMode) {
            setTimeout(function () {
              var returnUrl = window.location.pathname + window.location.search + window.location.hash;
              window.location.href = ORDER_VERIFICATION_PAGE + '?return_url=' + encodeURIComponent(returnUrl);
            }, 1500);
          }
          return Promise.reject(new Error('401'));
        }
        return data;
      });
  }

  function logPageStatistics(pageCode) {
    if (!pageCode) return Promise.resolve();
    return appRequest('https://crm.deerruner.com/crm/shopifyAssistant/pageStatistics/log', {
      method: 'POST',
      body: JSON.stringify({ pageCode: pageCode })
    }).catch(function () {});
  }

  function switchEmail() {
    try { localStorage.removeItem('tor_auth'); } catch (e) {}
    try { localStorage.removeItem('logined_email'); } catch (e) {}
    var path = window.location.pathname + window.location.search + window.location.hash;
    var idx = path.indexOf('/pages/');
    var returnUrl = idx >= 0 ? path.substring(idx) : path;
    window.location.href = ORDER_VERIFICATION_PAGE + '?return_url=' + encodeURIComponent(returnUrl);
  }

  window.appRequest = appRequest;
  window.getAppToken = getToken;
  window.logPageStatistics = logPageStatistics;
  window.switchEmail = switchEmail;
})();